exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2d0EVQ8nkCNcTwZe3a5GfO {\n  background-color: white !important;\n  border-color: #ced4da !important;\n  color: #ced4da !important;\n  min-width: 3rem;\n}\n._2d0EVQ8nkCNcTwZe3a5GfO:disabled {\n  opacity: 1;\n  background-color: #f8f9fa !important;\n}", ""]);
// Exports
exports.locals = {
	"outline-input-special": "_2d0EVQ8nkCNcTwZe3a5GfO"
};